const state = {
  entity: '',
}

export default state
